export const solarStep1 = {
    HighestGesamtertragClass: {
        url: "SolarInfo/gesamtertraege",
        receiveType: 'RECEIVE_Gesamtertrag_solarstep1Reducer'
    },
    SpezifischerGesamtertragClass: {
        url: "SolarInfo/spezifischerertrag",
        receiveType: 'RECEIVE_SpezifischerGesamtertrag_solarstep1Reducer'
    },
    HighestPowerClass: {
        url: "SolarInfoHighest/power",
        receiveType: 'RECEIVE_HIGHESTPOWER_solarstep1Reducer'
    },
    HighestBezugPowerClass: {
        url: "SolarInfoHighest/bezugPower",
        receiveType: 'RECEIVE_HIGHESTBEZUGPOWER_solarstep1Reducer'
    },
    TagesertragClass: {
        url: "SolarInfoHighest/tagesertrag",
        receiveType: 'RECEIVE_Tagesertrag_solarstep1Reducer'
    },
    SpezifischerClass: {
        url: "SolarInfoHighest/spezifischerertrag",
        receiveType: 'RECEIVE_Spezifischer_solarstep1Reducer'
    },
    JahresFinanzierungsfortschrittClass: {
        url: "Finanzierung/nochNoetigesGeldFuerDasJahr",
        receiveType: 'RECEIVE_JahresFinanzierungsfortschritt_solarstep1Reducer'
    },
    JahresGesamtstromverbrauchClass: {
        url: "StromVerbrauch/aktuellesJahr",
        receiveType: 'RECEIVE_JahresGesamtstromverbrauch_solarstep1Reducer'
    },
    AktuellerSpezifischerJahresertragClass: {
        url: "ErtragHeute/jahrspezifisch",
        receiveType: 'RECEIVE_AktuellerSpezifischerJahresertrag_solarstep1Reducer'
    },
    AktuellerGesamtertragJahrClass: {
        url: "ErtragHeute/gesamtjahr",
        receiveType: 'RECEIVE_AktuellerGesamtertragJahr_solarstep1Reducer'
    },
    AktuellerSpezifischerMonatsertragClass: {
        url: "ErtragHeute/smonatsertrag",
        receiveType: 'RECEIVE_AktuellerSpezifischerMonatsertrag_solarstep1Reducer'
    },
    AktuellerMonatsGesamtertragClass: {
        url: "ErtragHeute/monatgesamtertrag",
        receiveType: 'RECEIVE_AktuellerMonatsGesamtertrag_solarstep1Reducer'
    },
    AktuelleLeistungClass: {
        url: "ErtragHeute/leistung",
        receiveType: 'RECEIVE_AktuelleLeistung_solarstep1Reducer'
    },
    AktuellerTagesertragClass: {
        url: "SolarInfo/tagesertrag",
        receiveType: 'RECEIVE_AktuellerTagesertrag_solarstep1Reducer'
    },
    AktuellerSpezifischerTagesertragClass: {
        url: "ErtragHeute/stageserstrag",
        receiveType: 'RECEIVE_AktuellerSpezifischerTagesertrag_solarstep1Reducer'
    },

    BarDiagrammTageswerteClass: {
        url: "Diagramm/bar",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_BarDiagrammTageswerte_solarstep1Reducer'
    }
};